import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    examConditions: [],
    examCondition: {}
  },
  mutations: {
    index(state, payload) {
      state.examConditions = payload
    },
    show(state, payload) {
      state.examCondition = payload
    }
  },
  actions: {
    index({ commit }) {
      axios.get(`${ENV.API_URL}/api/exam_conditions`).then((res) => {
        commit('index', res.data)
      })
    },
    show({ commit }, payload) {
      axios.get(`${ENV.API_URL}/api/exam_conditions/${payload}`).then((res) => {
        commit('show', res.data)
      })
    },
    create({ commit }, payload) {
      axios.post(`${ENV.API_URL}/api/exam_conditions`, payload).then((res) => {
        commit('show', res.data)
      })
    },
    update({ commit }, payload) {
      axios.put(`${ENV.API_URL}/api/exam_conditions/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
      })
    }
  },
  getters: {
    examConditions: state => {
      return state.examConditions
    },
    examCondition: state => {
      return state.examCondition
    }
  },
  modules: {
  }
}
